import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { AdditionalStep } from '../models/additional-step.model';

const API_BASE = environment.TIMELINE_BASE;

@Injectable()
export class ChecklistTemplateService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getChecklist(task_template_id: number) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/check_list_template/task_template/${task_template_id}`,
    );
  }

  updateChecklist(body, task_template_id): Observable<AdditionalStep[]> {
    return this.http.put<any>(
      `${API_BASE}/companies/${this.companyId}/check_list_template/task_template/${task_template_id}`,
      body,
    );
  }
}
